import { useEffect, useState } from "react";
import { EnvelopeSimple, Lifebuoy } from "@phosphor-icons/react";
import api from "../../lib/api";
import AppLayout from "../../components/AppLayout";

export default function SupportPage() {
  const [wrm, setWrm] = useState(null);
  const [supportEmail, setSupportEmail] = useState("");

  useEffect(() => {
    api.get("/investor/profile").then((r) => setWrm(r.data.wrm)).catch(() => {});
    api.get("/public/config").then((r) => setSupportEmail(r.data.support_email || "")).catch(() => {});
  }, []);

  return (
    <AppLayout title="Support" subtitle="We're here to help with your account and investments.">
      <div className="fade-up grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl">
        <div className="glass-card p-7" data-testid="support-wrm-card">
          <p className="label-caps mb-5">Dedicated Relationship Manager</p>
          {wrm ? (
            <>
              <p className="font-display text-2xl text-white">{wrm.name}</p>
              <p className="text-sm text-zinc-500 mt-1">{wrm.title}</p>
              <div className="mt-5 space-y-2.5">
                <a href={`mailto:${wrm.email}`} data-testid="support-wrm-email"
                  className="flex items-center gap-2.5 text-sm text-emerald-400 hover:text-emerald-300 transition-colors duration-200">
                  <EnvelopeSimple size={15} /> {wrm.email}
                </a>
                <a href={`tel:${wrm.phone}`} data-testid="support-wrm-phone"
                  className="flex items-center gap-2.5 text-sm text-emerald-400 hover:text-emerald-300 transition-colors duration-200">
                  {wrm.phone}
                </a>
              </div>
            </>
          ) : (
            <p className="text-sm text-zinc-500">A relationship manager will be assigned shortly.</p>
          )}
        </div>

        <div className="glass-card p-7 border-emerald-500/15" data-testid="support-desk-card">
          <div className="h-11 w-11 rounded-xl bg-emerald-500/10 border border-emerald-500/25 text-emerald-400 flex items-center justify-center mb-5">
            <Lifebuoy size={22} weight="duotone" />
          </div>
          <p className="label-caps mb-2">Support Desk</p>
          <p className="font-display text-2xl text-white">How can we help?</p>
          <p className="text-sm text-zinc-500 mt-2 leading-relaxed">
            Write to our client services team and we will respond within one business day.
          </p>
          <div className="mt-6">
            <p className="label-caps mb-2">Email Support</p>
            {supportEmail ? (
              <>
                <p className="tnum text-sm text-emerald-300" data-testid="support-email">{supportEmail}</p>
                <a href={`mailto:${supportEmail}?subject=KMC%20Investor%20Portal%20—%20Support%20Request`}
                  data-testid="create-email-button"
                  className="inline-flex items-center gap-2 mt-4 text-sm font-bold text-[#030706] bg-emerald-500 hover:bg-emerald-400 rounded-lg px-5 py-2.5 emerald-glow transition-colors duration-200">
                  <EnvelopeSimple size={16} weight="bold" /> Create Email
                </a>
              </>
            ) : (
              <p className="text-sm text-zinc-500" data-testid="support-email-unconfigured">
                Support email is not configured. Set SUPPORT_EMAIL in the backend environment.
              </p>
            )}
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
